import APIKit from "../Allapis/Apikit/apikit";

export const getFaqs = async (id) => {
  const endpoint = id ? `/faqs/${id}` : `/faqs`;
  const res = await APIKit.get(endpoint);
  return res.data;
};

export const createFaqs = async (values) => {
  const res = await APIKit.post(`/faqs`, values);
  return res.data;
};

export const updateFaqs = async (id, values) => {
  const res = await APIKit.put(`/faqs/${id}`, values);
  return res.data;
};

export const deleteFaqs = async (faqs_id) => {
  const res = await APIKit.delete(`/faqs/${faqs_id}`);
  return res.data;
};
